import React, { useState, useEffect } from 'react';
import api from '../services/api';
import AdminLayout from '../components/Layout/AdminLayout';


const Azkar = () => {
  const [azkar, setAzkar] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('azkar');
  const [showModal, setShowModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [editingZikr, setEditingZikr] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    categoryId: '',
    arabicText: '',
    translation: '',
    transliteration: '',
    reference: '',
    repetitionCount: 1,
    benefits: '',
    displayOrder: 0,
    isActive: true
  });
  const [categoryFormData, setCategoryFormData] = useState({
    nameAr: '',
    nameEn: '',
    description: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [azkarRes, categoriesRes] = await Promise.all([
        api.get('/azkar/admin/all'),
        api.get('/azkar/categories')
      ]);
      setAzkar(azkarRes.data);
      setCategories(categoriesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingZikr) {
        await api.put(`/azkar/admin/${editingZikr.id}`, formData);
        alert('تم تحديث الذكر بنجاح');
      } else {
        await api.post('/azkar/admin', formData);
        alert('تم إضافة الذكر بنجاح');
      }
      setShowModal(false);
      resetForm();
      fetchData();
    } catch (error) {
      console.error('Error saving zikr:', error);
      alert('فشل في حفظ الذكر');
    }
  };

  const handleEdit = (zikr) => {
    setEditingZikr(zikr);
    setFormData({
      categoryId: zikr.categoryId,
      arabicText: zikr.arabicText,
      translation: zikr.translation || '',
      transliteration: zikr.transliteration || '',
      reference: zikr.reference || '',
      repetitionCount: zikr.repetitionCount,
      benefits: zikr.benefits || '',
      displayOrder: zikr.displayOrder,
      isActive: zikr.isActive
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الذكر؟')) {
      try {
        await api.delete(`/azkar/admin/${id}`);
        alert('تم حذف الذكر بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error deleting zikr:', error);
        alert('فشل في حذف الذكر');
      }
    }
  };

  const resetForm = () => {
    setEditingZikr(null);
    setFormData({
      categoryId: '',
      arabicText: '',
      translation: '',
      transliteration: '',
      reference: '',
      repetitionCount: 1,
      benefits: '',
      displayOrder: 0,
      isActive: true
    });
  };

  const getCategoryName = (id) => {
    const category = categories.find(c => c.id === id);
    return category ? category.nameAr : '';
  };

  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCategory) {
        await api.put(`/azkar/admin/categories/${editingCategory.id}`, categoryFormData);
        alert('تم تحديث الفئة بنجاح');
      } else {
        await api.post('/azkar/admin/categories', categoryFormData);
        alert('تم إضافة الفئة بنجاح');
      }
      setShowCategoryModal(false);
      setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
      setEditingCategory(null);
      fetchData();
    } catch (error) {
      console.error('Error saving category:', error);
      alert('فشل في حفظ الفئة');
    }
  };

  const handleDeleteCategory = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذه الفئة؟')) {
      try {
        await api.delete(`/azkar/admin/categories/${id}`);
        alert('تم حذف الفئة بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error deleting category:', error);
        alert('فشل في حذف الفئة');
      }
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center min-h-96">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-gold"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="p-6" dir="rtl">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">إدارة الأذكار</h1>
          <div className="flex gap-2">
            {activeTab === 'azkar' && (
              <button
                onClick={() => {
                  resetForm();
                  setShowModal(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                إضافة ذكر جديد
              </button>
            )}
            {activeTab === 'categories' && (
              <button
                onClick={() => {
                  setEditingCategory(null);
                  setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
                  setShowCategoryModal(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                إضافة فئة جديدة
              </button>
            )}
          </div>
        </div>

        <div className="mb-6 border-b border-gray-200">
          <nav className="flex gap-4">
            <button
              onClick={() => setActiveTab('azkar')}
              className={`pb-2 px-4 ${activeTab === 'azkar' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              الأذكار
            </button>
            <button
              onClick={() => setActiveTab('categories')}
              className={`pb-2 px-4 ${activeTab === 'categories' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              الفئات
            </button>
          </nav>
        </div>

        {activeTab === 'azkar' && (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">النص</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الفئة</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عدد التكرار</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الترتيب</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الحالة</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {azkar.map((zikr) => (
                <tr key={zikr.id}>
                  <td className="px-6 py-4 text-sm max-w-md truncate text-gray-800">{zikr.arabicText}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{getCategoryName(zikr.categoryId)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{zikr.repetitionCount}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{zikr.displayOrder}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded text-xs ${
                      zikr.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {zikr.isActive ? 'نشط' : 'غير نشط'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2 space-x-reverse">
                    <button
                      onClick={() => handleEdit(zikr)}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      تعديل
                    </button>
                    <button
                      onClick={() => handleDelete(zikr.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'categories' && (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالعربية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالإنجليزية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الوصف</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {categories.map((category) => (
                  <tr key={category.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{category.nameAr}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{category.nameEn}</td>
                    <td className="px-6 py-4 text-sm text-gray-800">{category.description}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2 space-x-reverse">
                      <button
                        onClick={() => {
                          setEditingCategory(category);
                          setCategoryFormData({
                            nameAr: category.nameAr,
                            nameEn: category.nameEn,
                            description: category.description || ''
                          });
                          setShowCategoryModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-900"
                      >
                        تعديل
                      </button>
                      <button
                        onClick={() => handleDeleteCategory(category.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto text-gray-900">
              <h2 className="text-xl font-bold mb-4 text-gray-900">
                {editingZikr ? 'تعديل ذكر' : 'إضافة ذكر جديد'}
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الفئة *</label>
                  <select
                    value={formData.categoryId}
                    onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  >
                    <option value="">اختر الفئة</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.nameAr}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">النص بالعربية *</label>
                  <textarea
                    value={formData.arabicText}
                    onChange={(e) => setFormData({ ...formData, arabicText: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="4"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الترجمة</label>
                  <textarea
                    value={formData.translation}
                    onChange={(e) => setFormData({ ...formData, translation: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">النقل الحرفي</label>
                  <input
                    type="text"
                    value={formData.transliteration}
                    onChange={(e) => setFormData({ ...formData, transliteration: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">المصدر</label>
                  <input
                    type="text"
                    value={formData.reference}
                    onChange={(e) => setFormData({ ...formData, reference: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">عدد التكرار *</label>
                  <input
                    type="number"
                    value={formData.repetitionCount}
                    onChange={(e) => setFormData({ ...formData, repetitionCount: parseInt(e.target.value) })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    min="1"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الفضائل</label>
                  <textarea
                    value={formData.benefits}
                    onChange={(e) => setFormData({ ...formData, benefits: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">ترتيب العرض</label>
                  <input
                    type="number"
                    value={formData.displayOrder}
                    onChange={(e) => setFormData({ ...formData, displayOrder: parseInt(e.target.value) })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    min="0"
                  />
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isActive"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                    className="mr-2"
                  />
                  <label htmlFor="isActive" className="text-sm font-medium text-gray-700">نشط</label>
                </div>

                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      resetForm();
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-100"
                  >
                    إلغاء
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    حفظ
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showCategoryModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full text-gray-900">
              <h2 className="text-xl font-bold mb-4 text-gray-900">
                {editingCategory ? 'تعديل فئة' : 'إضافة فئة جديدة'}
              </h2>
              <form onSubmit={handleCategorySubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالعربية *</label>
                  <input
                    type="text"
                    value={categoryFormData.nameAr}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, nameAr: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالإنجليزية</label>
                  <input
                    type="text"
                    value={categoryFormData.nameEn}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, nameEn: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الوصف</label>
                  <textarea
                    value={categoryFormData.description}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, description: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>
                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCategoryModal(false);
                      setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
                      setEditingCategory(null);
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-100"
                  >
                    إلغاء
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    حفظ
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Azkar;
